import { GlobalSearchQuery } from '../../../../generated/graphql'

type Count = number | null | undefined
const accumulator = {
    index: NaN,
    sum: 0,
}
type Accumulator = typeof accumulator
const checkAll = (numList: Count[]): Accumulator =>
    numList.reduce((acc: Accumulator, curr, index: number): Accumulator => {
        if (curr) {
            return {
                sum: acc.sum + curr,
                index,
            }
        }
        return acc
    }, accumulator)

const getSingleResultUrl = (data: GlobalSearchQuery): string | null => {
    const {
        accountCount,
        agentCount,
        vehicleCount,
        vehicleInSaleCount,
        vehicleRecentlySoldCount,
        accountResult,
        agentResult,
        vehicleInSaleResult,
        vehicleRecentlySoldResult,
        vehicleResult,
    } = data?.auction?.search || {}

    const counts = [accountCount, agentCount, vehicleCount, vehicleInSaleCount, vehicleRecentlySoldCount]

    const checks = checkAll(counts)
    let id: string | null | undefined
    if (checks.sum === 1) {
        switch (checks.index) {
            case 0:
                id = accountResult && accountResult[0]?.accountId
                return id ? `/details/companies?id=${id}` : null
            case 1:
                id = agentResult && agentResult[0]?.agentId
                return id ? `/details/agents?id=${id}` : null
            case 2:
                id = vehicleResult && (vehicleResult[0]?.stockNumber as string)
                return id ? `/details/vehicles?sn=${id}` : null
            case 3:
                id = vehicleInSaleResult && (vehicleInSaleResult[0]?.stockNumber as string)
                return id ? `/details/vehicles?sn=${id}` : null
            case 4:
                id = vehicleRecentlySoldResult && (vehicleRecentlySoldResult[0]?.stockNumber as string)
                return id ? `/details/vehicles?sn=${id}` : null
            default:
                throw new Error('Invalid result')
        }
    }
    return null
}

export default getSingleResultUrl
